import React, { Component } from 'react';
import BasePage from './BasePage';
import Session from '../services/session'
import Banner from '../partials/Banner';
import i from '../imports';
import c from '../components';
import d from '../dialogs';

import BreadCrumbs from '../partials/BreadCrumbs';

const EMPTY_FILTER_VALUE = "empty_filter_value";

const floatingLabelStyle = {
    color: "#FF5563"
}

const underlineStyle = {
    borderColor: "#FF5563"
}

const filterByTourName = (arr, currentTourName) => {
    return arr.filter((obj) => {
        for (let i = 0, length = obj.relation_tours.length; i < length; i++) {
            if (obj.relation_tours[i].tourpages === currentTourName) {
                return true;
            }
        }
        return false;
    });
}

class ExcursionPage extends Component {
    constructor() {
        super();
        this.state = {
            dateValue: new Date(),
            languageValue: EMPTY_FILTER_VALUE,
            toursNumberValue: 1,
            openDialog: false,
            excursionsToDisplay: 6,
            toursToDisplay: 3,
            destinationToDispaly: 3
        }
    }

    showMoreExcursions = () => {
        this.setState({excursionsToDisplay: this.state.excursionsToDisplay + 6})
    }

    showMoreTours = () => {
        this.setState({toursToDisplay: this.state.toursToDisplay + 6})
    }

    showMoreDestinations = () => {
        this.setState({destinationToDispaly: this.state.destinationToDispaly + 6})
    }

    handleDateChange = (event, date) => this.setState({
        dateValue: date
    });

    handleLanguageChange = (event, index, value) => this.setState({
        languageValue: value
    });

    handleToursNumberChange = (event, index, value) => this.setState({
        toursNumberValue: value
    });

    handleOpenDialog = () => {
        this.setState({
            openDialog: true
        })
    }

    handleCloseDialog = () => {
        this.setState({
            openDialog: false
        })
    }

    updateCalcValues = (calcValues) =>{
        this.setState({
            toursNumberValue:calcValues.toursNumberValue,
            languageValue:calcValues.languageValue,
            dateValue:calcValues.dateValue
        });
    }

    fillShortExcursionInfo(excursion){
        let excursionShortInfo = []
        
        // excursion.short_information.map(m => { 
        //     return {
        //         icon : i.faIcons[m.icon],
        //         text : m.text,
        //     }
        // });

        excursionShortInfo.push({
            icon : i.maIcons.ic_access_time,
            text :`${ Session.model.excursions.duration} : ${excursion.translations[0].duration || ''}` 
        });
        excursion.walking_tour_flag === true 
        ?
        excursionShortInfo.push({
            icon : i.maIcons.ic_directions_walk,
            text :`${ Session.model.excursions.walking_excursion}` 
        })
        :
        excursionShortInfo.push({
            icon : i.maIcons.ic_directions_car,
            text :`${ Session.model.excursions.car_excursion}` 
        });
        
        excursionShortInfo.push({
            icon: undefined,
            text: `${ Session.model.excursions.additional_payments}`
        });
        excursionShortInfo.push({
            icon: i.maIcons.ic_record_voice_over,
            text: `${ Session.model.excursions.guide_service} ${this.hideZeroPrice(excursion.translations[0].guide_service)}`
        });        
        excursionShortInfo.push({
            icon: i.maIcons.ic_headset,
            text: `${ Session.model.excursions.audioguide} ${this.hideZeroPrice(excursion.translations[0].audioguide)}`
        });
        excursionShortInfo.push({
            icon: i.faIcons.ticket,
            text: `${ Session.model.excursions.entrance_tickets} ${this.hideZeroPrice(excursion.translations[0].entrance_ticket_price)}`
        });

        return excursionShortInfo;
    }

    hideZeroPrice (price) {
        if(price === undefined || price == "" || price == 0)
            return ''
        return `: ${price}`;
    }

    calculatePrice(excursion){
        let numberOfTourists = this.state.toursNumberValue
        let priceByRange = excursion.price_ranges ? excursion.price_ranges.filter(f => f.number_from <= numberOfTourists && f.number_to >= numberOfTourists)[0] : undefined;
        let totalPrice = 'N/A';
        
        if(priceByRange && priceByRange.price)
            totalPrice = Number(priceByRange.price);
        return totalPrice;
    }

    getMaxTouristsNumber(excursion){

        let maxNumber =  excursion.price_ranges ? excursion.price_ranges.map(m => m.number_to).sort( function(a, b) {
            return a - b;
          }).reverse()[0] : 0;

          return maxNumber;
    }

    renederMenuItems(nubmer){
        var menuItems = [];
        for (var i = 0; i < nubmer; i++) {
            menuItems.push(<i.MenuItem value={i} primaryText={`${i}`} />);
        }
        return menuItems;
    }

    render() {
        let currentExcursion = this.props.data;

        let otherExcursions = Session.model.excursionPages.filter(f => f.name !== currentExcursion.name && f.destination === currentExcursion.destination )

        let currentDest = currentExcursion.destination;

        let relatedTourNames = currentExcursion.relation_tours.map(m => m.tourpages);
        let relatedTours = Session.model.tourPages.filter( (f) => 
        {
            if(relatedTourNames.indexOf(f.name) > -1)
                return true;
            return false;
        });
        let destinations = Session.model.destinationPages.filter(f => f.name !== currentDest.name);
        destinations = i.Utils.sortByIndex(destinations).slice(0, 3);

        let galleryPictures = currentExcursion.tourImages ? currentExcursion.tourImages.map( i => `${i.pic}` ) : [];

        let excursionShortInfo = this.fillShortExcursionInfo(currentExcursion);

        let menuItemsForSelection = i.Utils.createArrayOfNumbers(i.Utils.getMaxTouristsNumber(currentExcursion));
        //let menuItemsForSelection = i.Utils.createArrayOfNumbers(25);

        return (
            <BasePage data={this.props.data}>
            <BreadCrumbs fullpath={window.location.pathname} name={ i.Utils.getTranslationForProperty(currentExcursion.translations, 'title')} />

            <i.PureGridProvider>
                    <i.Container >
                        <i.Row>
                            <i.Col md={12} align='left' className="content-title" style={{ paddingBottom: "10px", paddingTop: "20px"}}>
                                {i.Utils.getTranslationForProperty(currentExcursion.translations, 'title')}
                            </i.Col>
                        </i.Row>
                        <i.Row >
                            <i.Col md={8} >
                                <div><c.Gallery images={galleryPictures} /></div>
                                <div className="content-text" style={{ paddingTop: "10px", textAlign: "justify"}}> {i.markdown(i.Utils.getTranslationForProperty(currentExcursion.translations, 'text'))} </div>
                            </i.Col>
                            <i.Col md={4} >
                                <c.IconsWithText data={excursionShortInfo} />
                            </i.Col>
                        </i.Row>
                        <i.Row style={{ paddingBottom: 20 }}>
                            <i.Col md={8} >
                                <i.Row>
                                    <i.Col align="left">
                                    <div style={{
                                        color: "#FF5563",
                                        fontSize: 18,
                                        paddingTop: 20,
                                        fontWeight: "bold"
                                    }}>{Session.model.excursions.price_calc}</div>
                                    </i.Col>
                                </i.Row>
                                <i.Row align="end">
                                    <i.Col xs={12} sm={6} align='left'>
                                        <i.SelectField
                                            floatingLabelText={Session.model.common.words.language}
                                            floatingLabelStyle={floatingLabelStyle}
                                            fullWidth
                                            value={this.state.languageValue}
                                            onChange={this.handleLanguageChange}
                                            underlineFocusStyle={underlineStyle} underlineStyle={underlineStyle}
                                        >
                                            <i.MenuItem value={EMPTY_FILTER_VALUE} primaryText={Session.model.tours.languages.choose_language} />
                                            <i.MenuItem value="Eng" primaryText={Session.model.tours.languages.en} />
                                            <i.MenuItem value="Ru" primaryText={Session.model.tours.languages.ru} />
                                            <i.MenuItem value="Es" primaryText={Session.model.tours.languages.es} />
                                        </i.SelectField>
                                    </i.Col>
                                    <i.Col xs={12} sm={6} align='left'>
                                    <i.SelectField
                                            floatingLabelText={Session.model.excursions.number_of_travellers}
                                            floatingLabelStyle={floatingLabelStyle}
                                            fullWidth
                                            underlineFocusStyle={underlineStyle}
                                            underlineStyle={underlineStyle}
                                            value={this.state.toursNumberValue}
                                            onChange={this.handleToursNumberChange}
                                        >
                                             {menuItemsForSelection.map(m => 
                                            <i.MenuItem value={m} primaryText={`${m}`} /> 
                                            )}
                                          
                                        </i.SelectField>
                                    </i.Col>
                                </i.Row>
                                <i.Row>
                                    <i.Col align="center">
                                    <div style={{
                                        color: "#FF5563",
                                        paddingTop: 40,
                                        fontSize: 18,
                                        fontWeight: "normal"
                                    }}>
                                    {`${Session.model.common.words.price_for_group || 'Стоимость в составе группы'} ${i.Utils.getGroupPriceTranslatedText(this.state.toursNumberValue)}`}:&nbsp;
                                        {(this.calculatePrice(currentExcursion)).toLocaleString("ru-RU")}
                                        <span style={{ textTransform: "uppercase" }}> {Session.model.common.words.rub}* </span>
                                    </div>
                                    <div style={{
                                        color: "#FF5563",
                                        fontSize: 12,
                                        paddingTop: 10,
                                        paddingBottom: 40,
                                        fontWeight: "normal"
                                    }}>*{Session.model.common.words.price_comment}</div>
                                    </i.Col>
                                </i.Row>
                                <i.Row style={{ paddingBottom: 30 }}>
                                    <i.Col xs={12} align="center">
                                    <button className='button' onClick={this.handleOpenDialog}>{Session.model.tours.button}</button>
                                    {/*<i.RaisedButton label="_REQUEST_"
                                        backgroundColor="#FF5563"
                                        labelColor="white"
                                        style={{backgroundColor: "#FF5563"}}/>*/}

                                    <d.TourDialog
                                        updateCalcValues={this.updateCalcValues}
                                        form_title={Session.model.tours.form_title}
                                        form_description={Session.model.tours.form_description}
                                        onClose={this.handleCloseDialog}
                                        openDialog={this.state.openDialog}
                                        currentTour={currentExcursion}
                                        calcValues={this.state}
                                    />
                                    </i.Col>
                                </i.Row>
                            </i.Col>
                            <i.Col md={4} align="left" style={{backgroundColor:"#F5F5F5", padding:"20px"}} >
                                <div style={{
                                    color: "#FF5563",
                                    fontSize: 18,
                                    fontWeight: "bold"
                                }}> {Session.model.excursions.seesighs_list}</div>
                                <div className="services-included" style={{align:"left", padding:"20px"}}>
                                    {i.markdown(i.Utils.getTranslationForProperty(currentExcursion.translations, 'exursion_places'))}
                                </div>
                            </i.Col>
                        </i.Row>
                        {otherExcursions.length > 0 ?
                        <i.Row style={{ paddingBottom: 20 }}>
                            <i.Col>
                                <div>
                                <h2>{`${Session.model.excursions.other_excursions}`}</h2>
                                <c.CardsList items={otherExcursions.slice(0, this.state.excursionsToDisplay)} urlBuilder={i.Utils.createExcursionUrl} />
                            </div>
                            </i.Col>
                        </i.Row>
                        : null
                        }
                        <i.Row style={{paddingBottom: 20}}>
                            <i.Col>
                                {otherExcursions.length > this.state.excursionsToDisplay 
                                    ? 
                                    <h2 style={{color: "#FF5563", cursor: "pointer"}} onClick={this.showMoreExcursions}>{Session.model.common.more}</h2> 
                                    : 
                                    <h2>
                                        {<i.NavLink style={{ color: "#FF5563", textDecoration: "none" }}
                                            to={i.Utils.locUrl(`excursions/`)}>
                                            {Session.model.common.words.find_more}
                                        </i.NavLink>}
                                    </h2>
                                }
                            </i.Col>
                        </i.Row>
                        {relatedTours.length > 0 ?
                            <i.Row style={{ paddingBottom: 20 }}>
                                <i.Col>
                                    <div>
                                        <h2>{`${Session.model.excursions.related_tours}`}</h2>
                                        <c.CardsList items={relatedTours} urlBuilder={i.Utils.createTourUrl} />
                                    </div>
                                </i.Col>
                            </i.Row>
                            : null
                        }
                        <i.Row style={{paddingBottom: 20}}>
                            <i.Col>
                                {relatedTours.length > this.state.toursToDisplay 
                                    ? 
                                    <h2 style={{color: "#FF5563", cursor: "pointer"}} onClick={this.showMoreTours}>{Session.model.common.more}</h2> 
                                    : 
                                    <h2>
                                    {<i.NavLink style={{ color: "#FF5563", textDecoration: "none" }}
                                        to={i.Utils.locUrl(`tours/}`)}>
                                        {Session.model.common.words.find_more}
                                    </i.NavLink>}
                                    </h2>
                                }
                            </i.Col>
                        </i.Row>
                        {destinations.length > 0 ?
                            <i.Row style={{ paddingBottom: 20 }}>
                                <i.Col>
                                    <div>
                                        <h2>{Session.model.common.words.other_destinations}</h2>
                                        <c.CardsList items={destinations} urlBuilder={i.Utils.createDestinationUrl} />
                                    </div>                                  
                                </i.Col>
                            </i.Row>
                        : null
                        }
                        <i.Row style={{paddingBottom: 20}}>
                            <i.Col>
                                {destinations.length > this.state.destinationToDispaly 
                                    ? 
                                    <h2 style={{color: "#FF5563", cursor: "pointer"}} onClick={this.showMoreDestinations}>{Session.model.common.more}</h2> 
                                    : 
                                    <h2><i.NavLink style={{ color: "#FF5563", textDecoration: "none" }} to={i.Utils.locUrl("destinations")}>{Session.model.common.words.find_more}</i.NavLink></h2>
                                }
                            </i.Col>
                        </i.Row>
                    </i.Container>
                </i.PureGridProvider>

          
        </BasePage>
        );
    }
}

export default ExcursionPage;